import React from 'react';
import { Navigate } from 'react-router-dom';
import { RouteConfig } from './types';

import AdminLogin from '@/pages/admin/login';
import AdminDashboard from '@/pages/admin/dashboard';
import AdminAcademyList from '@/pages/admin/academy/list';
import AdminAcademyNew from '@/pages/admin/academy/new';
import AdminAcademyDetail from '@/pages/admin/academy/detail';
import AdminTeacherDetail from '@/pages/admin/teacher/detail';
import AdminStudentManagement from '@/pages/admin/student';
import AdminStudentDetail from '@/pages/admin/student/detail';
import AdminStudentScheduleDetail from '@/pages/admin/student/scheduleDetail';
import AdminTeacherManagement from '@/pages/admin/teacher';
import AdminWithdrawalManagement from '@/pages/admin/withdrawal';
import AdminRegistrationManagement from '@/pages/admin/registration';
import AdminRegistrationDetail from '@/pages/admin/registration/detail';
import AdminSentenceManagement from '@/pages/admin/sentence';
import AdminSentenceDetail from '@/pages/admin/sentence/detail';
import AdminWordManagement from '@/pages/admin/word';
import AdminWordDetail from '@/pages/admin/word/detail';
import AdminWordbookManagement from '@/pages/admin/wordbook';
import AdminWordbookDetail from '@/pages/admin/wordbook/detail';
import AdminUnitList from '@/pages/admin/unit/list';
import AdminUnitDetail from '@/pages/admin/unit/detail';
import AdminTextbookList from '@/pages/admin/textbook/list';
import AdminTextbookDetail from '@/pages/admin/textbook/detail';
import AdminLearningManagement from '@/pages/admin/learning';
import AdminLearningRegister from '@/pages/admin/learning/register';
import AdminLearningDetail from '@/pages/admin/learning/detail';
import AdminLearningGradingDetail from '@/pages/admin/learning/grading/detail';
import AdminPaperList from '@/pages/admin/paper/list';  
import AdminPaperDetail from '@/pages/admin/paper/detail';
import AdminPaperSales from '@/pages/admin/paper/sales';
import AdminWordExamList from '@/pages/admin/word-exam/list';
import AdminWordExamDetail from '@/pages/admin/word-exam/detail';
import AdminTrophyBadgeList from '@/pages/admin/trophy-badge/list';
import AdminTrophyBadgeDetail from '@/pages/admin/trophy-badge/detail';
import AdminTrophyBadgeMasterList from '@/pages/admin/trophy-badge-master/list';
import AdminTrophyBadgeMasterDetail from '@/pages/admin/trophy-badge-master/detail';
import AdminExamResultList from '@/pages/admin/exam-result/list';
import AdminExamResultDetail from '@/pages/admin/exam-result/detail';

export const adminRoutes: RouteConfig[] = [
  {
    path: '/admin',
    name: '관리자 인덱스', 
    element: (
      <Navigate
        to={localStorage.getItem('admin_token') ? '/admin/dashboard' : '/admin/login'}
        replace
      />
    ),
    background: 'gradient',
    containerProps: { size: 'max' },
  },
  {
    path: '/admin/login',
    name: '관리자 로그인', 
    element: <AdminLogin />,
    background: 'gradient',
    containerProps: { size: 'max' },
  },
  {
    path: '/admin/dashboard',
    name: '관리자 대시보드', 
    element: <AdminDashboard />,
    background: 'gradient',
    containerProps: { size: 'max' },
    menuConfig: {
      key: 'dashboard',
      icon: 'DashboardOutlined',
      label: '대시보드',
    },
  },
  {
    path: '/admin/academy/list',
    name: '학원 리스트', 
    element: <AdminAcademyList />,
    background: 'gradient',
    containerProps: { size: 'max' },
    menuConfig: {
      key: 'academy-list',
      icon: 'BookOutlined',
      label: '학원 관리',
    },
  },
  {
    path: '/admin/academy/new',
    name: '학원 등록', 
    element: <AdminAcademyNew />,
    background: 'gradient',
    containerProps: { size: 'max' },
  },
  {
    path: '/admin/academy/detail/:academyCode',
    name: '학원 상세', 
    element: <AdminAcademyDetail />,
    background: 'gradient',
    containerProps: { size: 'max' },
  },
  {
    path: '/admin/teacher/:teacherId',
    name: '강사 상세', 
    element: <AdminTeacherDetail />,
    background: 'gradient',
    containerProps: { size: 'max' },
  },
  {
    path: '/admin/teacher',
    name: '강사 관리', 
    element: <AdminTeacherManagement />,
    background: 'gradient',
    containerProps: { size: 'max' },
    menuConfig: {
      key: 'teacher-management',
      icon: 'UserOutlined',
      label: '강사 관리',
    },
  },
  {
    path: '/admin/student',
    name: '학생 관리', 
    element: <AdminStudentManagement />,
    background: 'gradient',
    containerProps: { size: 'max' },
    menuConfig: {
      key: 'student-management',
      icon: 'UserOutlined',
      label: '학생 관리',
    },
  },
  {
    path: '/admin/student/detail/:studentId',
    name: '학생 상세', 
    element: <AdminStudentDetail />,
    background: 'gradient',
    containerProps: { size: 'max' },
  },
  {
    path: '/admin/student/schedule/:scheduleId',
    name: '학생 학습 상세',
    element: <AdminStudentScheduleDetail />,
    background: 'gradient',
    containerProps: { size: 'max' },
  },
  {
    path: '/admin/withdrawal',
    name: '탈퇴 신청관리', 
    element: <AdminWithdrawalManagement />,
    background: 'gradient',
    containerProps: { size: 'max' },
    menuConfig: {
      key: 'withdrawal-management',
      icon: 'CloseCircleOutlined',
      label: '탈퇴 신청관리',
    },
  },
  {
    path: '/admin/registration',
    name: '가입신청 관리', 
    element: <AdminRegistrationManagement />,
    background: 'gradient',
    containerProps: { size: 'max' },
    menuConfig: {
      key: 'registration-management',
      icon: 'UserAddOutlined',
      label: '가입신청 관리',
    },
  },
  {
    path: '/admin/registration/detail/:registrationId',
    name: '가입신청 상세', 
    element: <AdminRegistrationDetail />,
    background: 'gradient',
    containerProps: { size: 'max' },
  },
  {
    path: '/admin/sentence',
    name: '문장 관리',
    element: <AdminSentenceManagement />,
    background: 'gradient',
    containerProps: { size: 'max' },
    menuConfig: {
      key: 'sentence-management',
      icon: 'FileTextOutlined',
      label: '문장 관리',
    },
  },
  {
    path: '/admin/word',
    name: '단어 관리',
    element: <AdminWordManagement />,
    background: 'gradient',
    containerProps: { size: 'max' },
    menuConfig: {
      key: 'word-management',
      icon: 'BookOutlined',
      label: '단어 관리',
    },
  },
  {
    path: '/admin/word/create',
    name: '단어 등록',
    element: <AdminWordDetail />,
    background: 'gradient',
    containerProps: { size: 'max' },
  },
  {
    path: '/admin/word/detail/:wordId',
    name: '단어 학습',
    element: <AdminWordDetail />,
    background: 'gradient',
    containerProps: { size: 'max' },
  },
  {
    path: '/admin/sentence/create',
    name: '문장 등록',
    element: <AdminSentenceDetail />,
    background: 'gradient',
    containerProps: { size: 'max' },
  },
  {
    path: '/admin/sentence/detail/:sentenceId',
    name: '문장 상세',
    element: <AdminSentenceDetail />,
    background: 'gradient',
    containerProps: { size: 'max' },
  },
  {
    path: '/admin/wordbook',
    name: '단어장 관리',
    element: <AdminWordbookManagement />,
    background: 'gradient',
    containerProps: { size: 'max' },
    menuConfig: {
      key: 'wordbook-management',
      icon: 'BookOutlined',
      label: '단어장 관리',
    },
  },
  {
    path: '/admin/wordbook/create',
    name: '단어장 등록',
    element: <AdminWordbookDetail />,
    background: 'gradient',
    containerProps: { size: 'max' },
  },
  {
    path: '/admin/wordbook/detail/:wordbookId',
    name: '단어장 상세',
    element: <AdminWordbookDetail />,
    background: 'gradient',
    containerProps: { size: 'max' },
  },
  {
    path: '/admin/unit',
    name: '유닛 관리',
    element: <AdminUnitList />,
    background: 'gradient',
    containerProps: { size: 'max' },
    menuConfig: {
      key: 'unit-management',
      icon: 'AppstoreOutlined',
      label: '유닛 관리',
    },
  },
  {
    path: '/admin/unit/register',
    name: '유닛 등록',
    element: <AdminUnitDetail />,
    background: 'gradient',
    containerProps: { size: 'max' },
  },
  {
    path: '/admin/unit/:unitId',
    name: '유닛 상세',
    element: <AdminUnitDetail />,
    background: 'gradient',
    containerProps: { size: 'max' },
  },
  {
    path: '/admin/textbook',
    name: '교재 관리',
    element: <AdminTextbookList />,
    background: 'gradient',
    containerProps: { size: 'max' },
    menuConfig: {
      key: 'textbook-management',
      icon: 'BookOutlined',
      label: '교재 관리',
    },
  },
  {
    path: '/admin/textbook/add',
    name: '교재 등록',
    element: <AdminTextbookDetail />,
    background: 'gradient',
    containerProps: { size: 'max' },
  },
  {
    path: '/admin/textbook/:textbookId',
    name: '교재 상세',
    element: <AdminTextbookDetail />,
    background: 'gradient',
    containerProps: { size: 'max' },
  },
  {
    path: '/admin/learning',
    name: '학습관리',
    element: <AdminLearningManagement />,
    background: 'gradient',
    containerProps: { size: 'max' },
    menuConfig: {
      key: 'learning-management',
      icon: 'CalendarOutlined',
      label: '학습관리',
    },
  },
  {
    path: '/admin/learning/register',
    name: '학습 등록',
    element: <AdminLearningRegister />,
    background: 'gradient',
    containerProps: { size: 'max' },
  },
  {
    path: '/admin/learning/detail/:eventId',
    name: '학습 상세',
    element: <AdminLearningDetail />,
    background: 'gradient',
    containerProps: { size: 'max' },
  },
  {
    path: '/admin/learning/grading/detail/:scheduleId',
    name: '숙제 채점 상세',
    element: <AdminLearningGradingDetail />,
    background: 'gradient',
    containerProps: { size: 'max' },
  },
  {
    path: '/admin/paper',
    name: '유료 시험 관리',
    element: <AdminPaperList />,
    background: 'gradient',
    containerProps: { size: 'max' },
    menuConfig: {
      key: 'paper-management',
      icon: 'FileTextOutlined',
      label: '유료 시험 관리',
    },
  },
  {
    path: '/admin/paper/detail/add',
    name: '유료 시험 등록',
    element: <AdminPaperDetail />,
    background: 'gradient',
    containerProps: { size: 'max' },
  },
  {
    path: '/admin/paper/detail/:paperId',
    name: '유료 시험 상세',
    element: <AdminPaperDetail />,
    background: 'gradient',
    containerProps: { size: 'max' },
  },
  {
    path: '/admin/paper/sales',
    name: '시험 판매 내역',
    element: <AdminPaperSales />,
    background: 'gradient',
    containerProps: { size: 'max' },
  },
  {
    path: '/admin/paper/sales/:paperId',
    name: '시험 판매 내역(시험별)',
    element: <AdminPaperSales />,
    background: 'gradient',
    containerProps: { size: 'max' },
  },
  {
    path: '/admin/word-exam',
    name: '단어시험 관리',
    element: <AdminWordExamList />,
    background: 'gradient',
    containerProps: { size: 'max' },
    menuConfig: {
      key: 'word-exam-management',
      icon: 'FileTextOutlined',
      label: '단어시험 관리',
    },
  },
  {
    path: '/admin/word-exam/add',
    name: '단어시험 등록',
    element: <AdminWordExamDetail />,
    background: 'gradient',
    containerProps: { size: 'max' },
  },
  {
    path: '/admin/word-exam/detail/:wordExamId',
    name: '단어시험 상세',
    element: <AdminWordExamDetail />,
    background: 'gradient',
    containerProps: { size: 'max' },
  },
  {
    path: '/admin/trophy-badge',
    name: '트로피 및 뱃지 수여 관리',
    element: <AdminTrophyBadgeList />,
    background: 'gradient',
    containerProps: { size: 'max' },
    menuConfig: {
      key: 'trophy-badge-management',
      icon: 'TrophyOutlined',
      label: '트로피 및 뱃지 수여 관리',
    },
  },
  {
    path: '/admin/trophy-badge/add',
    name: '트로피 및 뱃지 수여 등록',
    element: <AdminTrophyBadgeDetail />,
    background: 'gradient',
    containerProps: { size: 'max' },
  },
  {
    path: '/admin/trophy-badge/detail/:trophyBadgeId',
    name: '트로피 및 뱃지 수여 상세',
    element: <AdminTrophyBadgeDetail />,
    background: 'gradient',
    containerProps: { size: 'max' },
  },
  {
    path: '/admin/trophy-badge-master',
    name: '트로피 및 뱃지 관리',
    element: <AdminTrophyBadgeMasterList />,
    background: 'gradient',
    containerProps: { size: 'max' },
    menuConfig: {
      key: 'trophy-badge-master-management',
      icon: 'TrophyOutlined',
      label: '트로피 및 뱃지 관리',
    },
  },
  {
    path: '/admin/trophy-badge-master/add',
    name: '트로피 및 뱃지 등록',
    element: <AdminTrophyBadgeMasterDetail />,
    background: 'gradient',
    containerProps: { size: 'max' },
  },
  {
    path: '/admin/trophy-badge-master/detail/:trophyBadgeId',
    name: '트로피 및 뱃지 수정',
    element: <AdminTrophyBadgeMasterDetail />,
    background: 'gradient',
    containerProps: { size: 'max' },
  },
  {
    path: '/admin/exam-result',
    name: '시험 성적표 관리',
    element: <AdminExamResultList />,
    background: 'gradient',
    containerProps: { size: 'max' },
    menuConfig: {
      key: 'exam-result-management',
      icon: 'FileTextOutlined',
      label: '시험 성적표 관리',
    },
  },
  {
    path: '/admin/exam-result/detail/:examResultId',
    name: '시험 성적표 상세',
    element: <AdminExamResultDetail />,
    background: 'gradient',
    containerProps: { size: 'max' },
  },
];

